module.exports = __webpack_public_path__ + "img/P8_popup_thumb_2_en.4308e539.png";